import { render } from "./output.vue?vue&type=template&id=32de103e"
import script from "./output.vue?vue&type=script&lang=js"
export * from "./output.vue?vue&type=script&lang=js"

import exportComponent from "/home/minify-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__